import { apiClient } from '@/lib/apiClient';
import type {
  FornecedorResumo,
  FornecedorDetalhe,
  CriarFornecedorRequest,
  AtualizarFornecedorRequest,
  PaginadoResponse,
} from '../types';

const BASE = '/api/compras/fornecedores';

/** Filtros da consulta (contrato §4 de PADRAO_PAGINAS_CADASTRO.md). Datas em yyyy-MM-dd. */
export interface FiltroFornecedores {
  busca?: string;
  situacao?: 'ativos' | 'inativos' | 'todos';
  dtInicio?: string;
  dtFim?: string;
  ordenarPor?: string;
  direcao?: 'asc' | 'desc';
  pagina?: number;
  tamanhoPagina?: number;
}

export interface FornecedoresResumoKpi {
  total: number;
  ativos: number;
  inativos: number;
}

/** Remove vazios para não poluir a query string. */
const params = (f: FiltroFornecedores) =>
  Object.fromEntries(Object.entries(f).filter(([, v]) => v !== undefined && v !== null && v !== ''));

export const fornecedorService = {
  async getAll(pagina = 1, tamanhoPagina = 20, apenasAtivos = true): Promise<PaginadoResponse<FornecedorResumo>> {
    const { data } = await apiClient.get<PaginadoResponse<FornecedorResumo>>(BASE, {
      params: { pagina, tamanhoPagina, apenasAtivos },
    });
    return data;
  },

  /** Busca, filtros, ordenação e paginação no servidor. */
  async listar(filtro: FiltroFornecedores): Promise<PaginadoResponse<FornecedorResumo>> {
    const { data } = await apiClient.get<PaginadoResponse<FornecedorResumo>>(BASE, { params: params(filtro) });
    return data;
  },

  /** KPIs sobre a busca/período (ignora situação e paginação). */
  async resumo({ busca, dtInicio, dtFim }: FiltroFornecedores): Promise<FornecedoresResumoKpi> {
    const { data } = await apiClient.get<FornecedoresResumoKpi>(`${BASE}/resumo`, {
      params: params({ busca, dtInicio, dtFim }),
    });
    return data;
  },

  async buscar(q: string, limite = 20): Promise<FornecedorResumo[]> {
    const { data } = await apiClient.get<FornecedorResumo[]>(`${BASE}/busca`, {
      params: { q, limite },
    });
    return data;
  },

  async getById(id: number): Promise<FornecedorDetalhe> {
    const { data } = await apiClient.get<FornecedorDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async create(request: CriarFornecedorRequest): Promise<FornecedorDetalhe> {
    const { data } = await apiClient.post<FornecedorDetalhe>(BASE, request);
    return data;
  },

  async update(id: number, request: AtualizarFornecedorRequest): Promise<FornecedorDetalhe> {
    const { data } = await apiClient.put<FornecedorDetalhe>(`${BASE}/${id}`, request);
    return data;
  },
};
